import { ReactElement } from 'react';

import { GoForwardButton } from '../../GoForwardButton';
import { useWindowSizeStore } from '../../../../stores/useWindowSizeStore';
import { useLoadingStore } from '../../../../stores/useLoadingStore';
import { CartIcon } from '../../../icons/CartIcon';
import Loading from '../../../icons/Loading';
import { useIncludeFunctionaryForm } from '../../../../contexts/IncludeFunctionaryFormProvider';
import { useRouteLoaderData } from 'react-router-dom';

export function ConfirmForm(): ReactElement {
  const { handleSubmit, onSubmit } = useIncludeFunctionaryForm();
  const loading = useLoadingStore(state => state.loading);
  const data: any = useRouteLoaderData('Empresa-token');
  const width = useWindowSizeStore(state => state.width);

  return (
    <form action="" className="max-w-[766px] w-full">
      <>
        <h2 className="text-[2rem] font-semibold text-center text-primary-main">
          Suas informações foram recebidas com sucesso!
        </h2>
        <p className="font-normal mt-1 text-justify mb-8">
          Confirmamos seu pedido de adesão ao plano odontológico da empresa{' '}
          {data.nome_fantasia}. Sua adesão será comunicada ao RH / Gestor do
          processo de adesão ao plano na sua empresa e assim que aprovada e ,
          estando dentro das regras estabelecidas, seu plano será ativado.
        </p>
        <p className="font-normal mt-1 text-center mb-8">
          Clique no botão abaixo para “concluir adesão’
        </p>
        <p className="font-normal font-semibold mt-1 text-center mb-8">
          Baixe o aplicativo da Odontogroup e encontre um dentista mais próximo
          de você!
        </p>
      </>
      <GoForwardButton
        disabled={loading}
        addBackButton
        onForwardClick={handleSubmit(onSubmit)}
        Icon={loading ? Loading : CartIcon}
        desktopText={loading ? '' : 'concluir adesão'}
        mobileText={loading ? '' : 'concluir adesão'}
      />
    </form>
  );
}
